<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="mb-5">
          <p class="fw-500">Nomor Rangka</p>
          <AtomTable label="Nama" :value="infoKendaraan.nama" type="row" />
          <!-- <AtomTable
            label="Nomor Rangka"
            :value="infoKendaraan.no_Chasis"
            type="row"
          /> -->
        </div>
        <div class="">
          <p class="fw-500">Info Data Kendaraan</p>
          <AtomTable
            label="Nomor Polisi"
            :value="infoKendaraan.nopol"
            type="row"
          />
          <AtomTable label="Warna" :value="infoKendaraan.warna" type="row" />
          <AtomTable
            label="Golongan"
            :value="infoKendaraan.golongan"
            type="row"
          />
          <AtomTable label="Merk" :value="infoKendaraan.merk" type="row" />
          <AtomTable label="Tipe" :value="infoKendaraan.type" type="row" />
          <AtomTable
            label="Tahun Buat"
            :value="infoKendaraan.tahun_Buat"
            type="row"
          />
          <AtomTable
            label="Tanggal Masa Berlaku"
            :value="infoKendaraan.tanggal_MasaLaku"
            type="row"
          />
        </div>
      </div>
    </div>
    <br />
    <div class="row justify-content-end">
      <div class="col-12 col-md-5 col-lg-2 mb-3 mb-md-0">
        <v-btn @click="handleKembali" class="btn btn-kembali w-100">
          <box-icon name="arrow-back" color="#67747E" class="mr-2"></box-icon>
          Kembali
        </v-btn>
      </div>
      <div class="col-12 col-md-5 col-lg-2">
        <v-btn @click="handleLanjut" class="btn btn-primary w-100"
          >Lanjut</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoKendaraan",
  components: {
    AtomTable: () => import("@/components/atoms/AtomTable"),
  },
  computed: {
    infoKendaraan() {
      return this.$store.state.main.infoKendaraan;
    },
  },
  methods: {
    handleKembali() {
      this.$store.commit("SET_STEPPER_ACTIVE", 0);
    },
    handleLanjut() {
      this.$store.commit("SET_STEPPER_ACTIVE", 2);
    },
  },
};
</script>
